import React, { useState, useEffect } from "react";
import "../Styles/header.css";
import titleImg from "../../SVG/TitleAdm.svg";
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../../Components/LanguageSwitcher"
import { Skeleton } from "antd";

import { useLocation } from "react-router-dom";
import authService from "../../services/authService";
import { getAdminNavbarPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { StrapiError } from "../../Inicio/Pages/StrapiError";

function AdminTitle(props) {
  const { locale } = useLocale();
  const [adminNavbarPage, setAdminNavbarPage] = useState(null);
  const [titulo, setTitulo] = useState("ADMINISTRACIÓN CENFOTEC");
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);
    getAdminNavbarPage(locale)
      .then((res) => {
        clearTimeout(timeoutId);
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminNavbarPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch((error) => { 
        clearTimeout(timeoutId);
        if (!cancel) {
          setAdminNavbarPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => { cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale])

  useEffect(() => {
    if (location.pathname == "/Admin") setTitulo(adminNavbarPage?.home_nb || "ADMINISTRACIÓN CENFOTEC");
    else if (location.pathname == "/Admin/solicitudes")
      setTitulo(adminNavbarPage?.application_nb || "ADMINISTRACIÓN DE SOLICITUDES");
    else if (location.pathname == "/Admin/listaArchivos") setTitulo(adminNavbarPage?.fiels_nb || "ARCHIVOS");
    else if (location.pathname == "/Admin/configuracionPerfil")
      setTitulo(adminNavbarPage?.profilesetting_nb || "AJUSTES DE USUARIO");
    else setTitulo(adminNavbarPage?.setting_nb || "CONFIGURACIÓN");
  }, [location, adminNavbarPage]);

  const hideSidebar = () => {
    const sidebar = document.querySelector(".sideBar");
    const closeBtn = document.querySelectorAll(".toggleBtnAdm");
    sidebar.classList.toggle("sideBarVisible");

    closeBtn.forEach((el) => {
      el.classList.toggle("invisibleBtn");
    });
  };

  if (isLoadingContent) {
    return (
      <>
        <header>
          <div className="image-container">
            <Skeleton.Image style={{ width: 200, height: 60 }} />
          </div>
          <div className="align-self-center">
            <Skeleton.Input style={{ width: 300, height: 40 }} active />
          </div>
          <div className="align-self-center ml-auto">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div className="nav-language-switcher" style={{ display: "flex", alignItems: "center" }}>
                <div className="language-switcher-container">
                  <LanguageSwitcher />
                </div>
              </div>
              <div className="userTitle" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Skeleton.Input style={{ width: 150, height: 20 }} active />
                <Skeleton.Button style={{ width: 40, height: 40 }} active />
              </div>
            </div>
          </div>
        </header>
        <Skeleton.Button style={{ width: 50, height: 50 }} active />
        <Skeleton.Button style={{ width: 50, height: 50 }} active />
      </>
    );
  }

  if (hasError && locale === 'en') {

    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setAdminNavbarPage(null);
      }}
    />
  }

  return (
    <>
      <header>
        <div className="image-container">
          <img
            src={titleImg}
            className="headerImg"
            alt="Imagen admnistración "
          />
        </div>
        <div className="align-self-center">
          <h1 className="titleSolicitudes">{titulo}</h1>
        </div>

        <div className="align-self-center ml-auto">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div className="nav-language-switcher" style={{ display: "flex", alignItems: "center" }}>
              <div className="language-switcher-container">
                <LanguageSwitcher />
              </div>
            </div>
            <div className="userTitle" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <h4 style={{ margin: 0 }}>{props.usuarioNombre}</h4>
              <button
                onClick={() => {
                  authService.logout(navigate);
                }}
              >
                <i className="material-icons"></i>
              </button>
            </div>
          </div>
        </div>
      </header>
      <button className="toggleBtnAdm" onClick={hideSidebar}>
        <i className="material-icons"></i>
      </button>
      <button className="toggleBtnAdm invisibleBtn" onClick={hideSidebar}>
        <i className="material-icons"></i>
      </button>
    </>
  );
}

export default AdminTitle;
